import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { NonIntrusive } from "./components/nonIntrusive";
import { Intrusive } from "./components/intrusive";
const NerdNotifier = (props) => {
    const { notification, children, onClose } = props;
    const { variant = "non-intrusive", uuid } = notification;
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (uuid) {
            setOpen(true);
        }
    }, [uuid]);
    const handleClose = () => {
        setOpen(false);
        onClose?.();
    };
    return (_jsxs(_Fragment, { children: [children, variant === "non-intrusive" && open && (_jsx(NonIntrusive, { ...notification, open: open, handleClose: handleClose })), variant === "intrusive" && (_jsx(Intrusive, { ...notification, open: open, onHandleClose: handleClose }))] }));
};
export default NerdNotifier;
